import exempleTeam from '../../../../assets/icons/team.jpg'

export const newGroups = {
  data: {
    type: 'roundRobin',
    tournamentMember: [
      {
        id: '01G3NJCPAC1V9T0PJ1JKMRE3Z6',
        user: {
          id: '01G3NG6ZFZ9DXCRTPXHCZ1QDX6',
          nickname: '',
          avatar: '',
          flag: '',
        },
        team: null,
      },
      {
        id: '01G3NJFZCVN6PREPTSAWKQDHMC',
        user: {
          id: '01G3HB6HTJWF40Y5TRKN39190B',
          nickname: '',
          avatar: '',
          flag: '',
        },
        team: null,
      },
      {
        id: '01G3NJGXJTJ1F4BG9KTA6X1F51',
        user: {
          id: '01G3HB7NS6YDCZFW738CW55FNX',
          nickname: '',
          avatar: '',
          flag: '',
        },
        team: null,
      },
      {
        id: '01G3NJM7WR50H3GM43VFBN2YTB',
        user: {
          id: '01G3HBB5A19ZAPZWNHSWMG49VS',
          nickname: '',
          avatar: '',
          flag: '',
        },
        team: null,
      },
      {
        id: '01G3NJNDEDXJKX52R8254Q8K01',
        user: {
          id: '01G3HBBKXCD3RK26VM998HWS2J',
          nickname: '',
          avatar: '',
          flag: '',
        },
        team: null,
      },
      {
        id: '01G3NJQD19WF4Z8276J1YA2Z1Z',
        user: {
          id: '01G3HBDKC8H9PR8K7NRNMZWQGV',
          nickname: '',
          avatar: '',
          flag: '',
        },
        team: null,
      },
      {
        id: '01G3NJR0EF22BNTPVK6E9H80RS',
        user: {
          id: '01G3HBDT687W161YY7TNFQC8CS',
          nickname: '',
          avatar: '',
          flag: '',
        },
        team: null,
      },
      {
        id: '01G3NJSAXDGARDAFA061GZ48KT',
        user: {
          id: '01G3HBFVM6DZJ4R8QAHXPD42WM',
          nickname: '',
          avatar: '',
          flag: '',
        },
        team: null,
      },
      {
        id: '01G3NJW1JXRWG6PX1D91ECE2M7',
        user: {
          id: '01G3HBKR3QD83ZTFXBWP6VT1BM',
          nickname: '',
          avatar: '',
          flag: '',
        },
        team: null,
      },
    ],
    basket: [
      {
        cols: [
          {
            name: 'Group 1',
            rows: [
              {
                tournamentMemberId: '01G3NJFZCVN6PREPTSAWKQDHMC',
                position: 1,
                score: '',
              },
              {
                tournamentMemberId: '01G3NJGXJTJ1F4BG9KTA6X1F51',
                position: 2,
                score: '',
              },
              {
                tournamentMemberId: '01G3NJQD19WF4Z8276J1YA2Z1Z',
                position: 3,
                score: '',
              },
              {
                tournamentMemberId: '01G3NJCPAC1V9T0PJ1JKMRE3Z6',
                position: 4,
                score: '',
              },
              {
                tournamentMemberId: '01G3NJR0EF22BNTPVK6E9H80RS',
                position: 5,
                score: '',
              },
            ],
          },
        ],
        type: 'standart',
      },
    ],
  },
}
